import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/wf';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-314" data-mp="put0j5lnegcy">
      <div className="mx-auto max-w-6xl" data-id="element-315" data-mp="b6ohu1mli4u6">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-316" data-mp="b4vasl82liln">
          Co zawiera <em className="text-red-700" data-id="element-317" data-mp="2603t6x7c4ha">WF GOTOWY™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-318" data-mp="23nci35k0hrk">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-319" data-mp="75mizlwlbusq">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-320" data-mp="3tc1hln8jxc6m">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Tomy" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-321" data-mp="3ctecs9nsb72p">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-322" data-mp="3luvo7eq8ykl2" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-323" data-mp="2y3qb37boy6eg">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none" data-id="element-324" data-mp="2adw06vaxmrwu">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-325" data-mp="26d2bhzpo192w">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-326" data-mp="eazkv5c4fcwy">
          <AnimatePresence mode="wait" initial={false} data-id="element-327" data-mp="o2426bp9r9uy">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-328" data-mp="o0sq7olo6vsr">
              <div className="lg:col-span-5" data-id="element-329" data-mp="5bw4i94c9bm5">
                <p className="text-sm font-semibold text-red-700" data-id="element-330" data-mp="5cxd86xvtm0p">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-331" data-mp="1gqj6a36v47ri">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-332" data-mp="3193dvexr7wws">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-333" data-mp="2w9h116lu8ioi">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-334" data-mp="2rhyywf82wc1y">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-335" data-mp="2rgnvigijp6bd">Zawiera</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-336" data-mp="2mjnq87tis7lb">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-337" data-mp="2hm5qn81e74pz">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-338" data-mp="2dlc0s94e3fug" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-339" data-mp="23mwcedwqykon">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-340" data-mp="1totkuhxdky0">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-341" data-mp="2vjk4bzsepi0j">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-342" data-mp="2zlyrgw33z3xm">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-343" data-mp="2lo0d3qosf7i4">
              Co wyróżnia WF GOTOWY™?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-344" data-mp="2qood31uzuyoh">
              Materiały do WF na cały rok szkolny – uporządkowane i gotowe do użycia.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-345" data-mp="2gqia0gxgbmi1">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-346" data-mp="27wvl9arnvjic">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-347" data-mp="27tps9kfwvxhc" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-348" data-mp="1t15vr2n9oo8v">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-349" data-mp="1ec4hewik0gtn">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}